// extracted by mini-css-extract-plugin
export default {"Nav":"Nav_Nav__Pztn4","Nav__Logo":"Nav_Nav__Logo__d6zq5","Nav__BurgerMenu":"Nav_Nav__BurgerMenu__WEYl1"};